import { FormEvent, useEffect, useState } from 'react';
import * as _ from 'lodash';
import { ICenterBase } from '@nkr/models/center-base';
import { IFindForTransferResponse } from '@nkr/store/dash';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal, Row, Well } from 'react-bootstrap';

interface IProps {
    show: boolean,
    name: string,
    email: string,
    birthDate: string,
    currentCenterId: number,
    currentCenterAlias: string,
    centerList: ICenterBase[],
    container: any,
    onCheckRegistration: (centerId: number, email: string, birthDate: string) => Promise<IFindForTransferResponse>,
    onRequestTransfer: (centerId: number) => void,
    onCompleteTransfer: (existingId: number) => void,
    onCancel: () => void
}

const TransferDonor = (props: IProps) => {
    const [selectedCenter, setSelectedCenter] = useState(0);
    const [hasChecked, setHasChecked] = useState(false);
    const [existingId, setExistingId] = useState(0);
    const [alreadyAssigned, setAlreadyAssigned] = useState(false);

    useEffect(() => {
        if (props.show == false) {
            setSelectedCenter(0);
            setHasChecked(false);
            setExistingId(0);
            setAlreadyAssigned(false);
        }
    }, [props.show])

    const handleCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        setSelectedCenter(parseInt(e.currentTarget.value));

        setHasChecked(false);
        setExistingId(0);
        setAlreadyAssigned(false);
    };

    const handleCheckRegistration = () => {
        let { email, birthDate } = props;

        props.onCheckRegistration(selectedCenter, email, birthDate).then(response => {
            setHasChecked(true);

            if (response.data.results.length > 0) {
                setExistingId(response.data.results[0].id);

                let alreadyAssigned = response.data.results.find(x => x.donorConnectAlreadyAssigned) != null;

                setAlreadyAssigned(alreadyAssigned);
            } else {
                setExistingId(0);
            }
        });
    };

    const handleRequestTransfer = () => {
        props.onRequestTransfer(selectedCenter);
    };

    const handleCompleteTransfer = () => {
        props.onCompleteTransfer(existingId);
    };

    const getSelectedCenterAlias = () => {
        let center = props.centerList.find(x => x.id == selectedCenter);

        if (center != null) {
            return center.alias;
        }

        return '';
    };

    const centerList = _.sortBy(props.centerList.filter(x => x.id != props.currentCenterId), item => item.alias);
    const selectedCenterAlias = getSelectedCenterAlias();

    return (
        <>
            <Modal backdrop='static' show={props.show} onHide={props.onCancel} container={props.container}>
                <Modal.Header closeButton>
                    <Modal.Title>Transfer Donor</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form horizontal>
                        <Well style={{ paddingTop: 7.5, paddingBottom: 7.5, marginBottom: 10 }}>
                            <Row>
                                <Col xs={2}>Name:</Col>
                                <Col xs={9}>{props.name}</Col>
                            </Row>
                            <Row>
                                <Col xs={2}>Email:</Col>
                                <Col xs={9}>{props.email}</Col>
                            </Row>
                            <Row>
                                <Col xs={2}>DOB:</Col>
                                <Col xs={9}>{props.birthDate}</Col>
                            </Row>
                        </Well>

                        <FormGroup>
                            <Col xs={12} lg={5} componentClass={ControlLabel}>This registration is currently at:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl.Static>
                                    {props.currentCenterAlias != null ? props.currentCenterAlias : '- pending selection -'}
                                </FormControl.Static>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={5} componentClass={ControlLabel}>However, the candidate is at:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    componentClass='select'
                                    value={selectedCenter}
                                    onChange={handleCenterChange}
                                >
                                    <option value={0}>- Select Center -</option>
                                    {centerList.map(center =>
                                        <option key={'ctr-' + center.id} value={center.id}>{center.alias}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>
                    </Form>

                    {hasChecked && existingId == 0 && (
                        <Alert bsStyle='warning'>
                            We could not find an existing registration at {selectedCenterAlias}.  In order to transfer the donor registration, we will need to send a
                            notification to {props.currentCenterAlias} letting them know why the donor does not appear in their list.  Please ensure this donor has definitely
                            ceased communication with {props.currentCenterAlias} before continuing.
                        </Alert>
                    )}

                    {hasChecked && existingId > 0 && !alreadyAssigned && (
                        <Alert bsStyle='warning'>
                            We found a registration at {selectedCenterAlias} matching the same email and date of birth.  Please click the button below to transfer the
                            Donor Mentor details to the {selectedCenterAlias} registration.  Due to the nature of transferring donor mentor details to a different
                            registration, there is a risk that some data might get lost, so please inform NKR if anything is missing after the transfer.
                        </Alert>
                    )}

                    {hasChecked && existingId > 0 && alreadyAssigned && (
                        <Alert bsStyle='warning'>
                            We found a registration at {selectedCenterAlias} matching the same email and date of birth.  This registration is already in Donor Mentor.
                        </Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {!hasChecked && (
                        <Button bsStyle='primary' disabled={selectedCenter == 0} onClick={handleCheckRegistration}>Check for Existing Registration</Button>
                    )}

                    {hasChecked && existingId == 0 && (
                        <Button bsStyle='primary' onClick={handleRequestTransfer}>I understand, request transfer</Button>
                    )}

                    {hasChecked && existingId > 0 && !alreadyAssigned && (
                        <Button bsStyle='primary' onClick={handleCompleteTransfer}>I understand, complete transfer</Button>
                    )}

                    <Button onClick={props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default TransferDonor;